import { useNavigate } from "react-router-dom";
import Page3 from "../assets/page3.png";
import { FormattedMessage } from "react-intl";
import { useState } from "react";

const TertiaryInstruction = () => {
  const navigate = useNavigate();
  const [isButtonDisabled, setIsButtonDisabled] = useState(false);

  const handleNext = () => {
    setIsButtonDisabled(true);
    navigate("/live_stream");
  };

  return (
      <>
        <div className="top-row">
          <FormattedMessage id="addPhoneSecondary" />
        </div>
        <div className="mid-row">
          <div className="top-midrow">
            <div className="div1">
              <div className="pagenumber">3</div>
              <div className="runningtext">
                <FormattedMessage id="phoneTetherPrompt" />
              </div>
            </div>
            <div className="div2 iconHolder">
              <img src={Page3} alt="Allow permission icon" />
            </div>
          </div>
          <div className="btm-midrow">
            <div className="div1">
              <div className="runningtext2">
                <FormattedMessage id="viewDemoVideo" />
              </div>
            </div>
              <div className="div2">
                  <div className="videoHolder">
                      <video
                          aria-label="demo video"
                          tabIndex={1}
                          className="videoPlayer"
                          src="https://cdn.proview.io/assets/secondary_cam.mp4"
                          id="tvp_demo_video"
                          controls
                          disablePictureInPicture
                          controlsList="nodownload"
                      />
                  </div>
              </div>
          </div>
        </div>
        <div className="btm-row">
          <button tabIndex={2} className="btn" onClick={handleNext} disabled={isButtonDisabled}>
            <FormattedMessage id="next" />
          </button>
        </div>
      </>
  );
};

export default TertiaryInstruction;
